import type {
  IResponseApi,
  IResponseApiSearch
} from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
export class UserService extends BaseService<any> {
  constructor () {
    super({
      baseUrl: 'system/user/'
    })
  }
  async listUser<T> (
    tipo: string,
    id: number
  ): Promise<AxiosResponse<IResponseApi<T[]>>> {
    return this.http.get<IResponseApi<T[]>>(`/list/${id}/${tipo}`)
  }

  // Buscar elementos con parámetros
  async searchUser<T> (
    tipo: string,
    params: Record<string, unknown>
  ): Promise<AxiosResponse<IResponseApiSearch<T[]>>> {
    return this.http
      .get<IResponseApiSearch<T[]>>(`/search/${tipo}`, { params })
      .catch(this.errorHandle)
  }

  // Ver un elemento por ID
  async viewUser<T> (
    tipo: string,
    id: number | string | string[]
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http.get<T>(`/view/${id}/${tipo}`).catch(this.errorHandle)
  }

  // Crear un nuevo elemento
  async createUser<T> (
    tipo: string,
    data: T
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http.post<T>(`/create/${tipo}`, data).catch(this.errorHandle)
  }

  // Actualizar un elemento por ID
  async updateUser<T> (
    tipo: string,
    id: number | string,
    data: Partial<T>
  ): Promise<AxiosResponse<IResponseApi<T>>> {
    return this.http
      .put<T>(`/update/${tipo}/${id}`, data)
      .catch(this.errorHandle)
  }

  // Eliminar un elemento por ID
  async deleteUser (
    id: number | string
  ): Promise<AxiosResponse<IResponseApi<void>>> {
    return this.http.delete<void>(`/delete/${id}`).catch(this.errorHandle)
  }
}
